/**
 * This file is auto-generated from Logo.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const logo: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Healed Logo';
        case 'pl':
            return 'Logo Healed';
    }
};
